function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ElementModel } from './ElementModel';
import * as Y from 'yjs';
import { EditorConfig } from '../../edit/EditorConfig';
export class SelectorModel extends ElementModel {
  get drawPoints() {
    if (this.localPoints.length >= 4) {
      return this.localPoints;
    }
    return this.points;
  }
  constructor(root, scope, liveCursor, isPerformanceMode) {
    super(root, scope, liveCursor, isPerformanceMode);
    _defineProperty(this, "item", null);
    _defineProperty(this, "clearLocalPointsWhenYPointsChange", true);
    _defineProperty(this, "shouldUseLocalPoints", true);
    _defineProperty(this, "localPointsPick", 4);
    if (this.root.doc && !this.root.has('type')) {
      this.root.set('type', 'selector');
    }
    if (this.root.doc && !this.root.has('points')) {
      const initPoints = new Y.Array();
      initPoints.push([0, 0, 0, 0]);
      this.root.set('points', initPoints);
    }
  }
  liveCursorPoint() {
    return null;
  }
  subDispose() {}
  createPaperRect() {
    const scope = this.scope;
    const bounds = new scope.Rectangle(new scope.Point(this.drawPoints[0], this.drawPoints[1]), new scope.Size(this.drawPoints[2], this.drawPoints[3]));
    return new scope.Path.Rectangle(bounds);
  }
  onVectorUpdate() {
    if (!this.item) {
      return;
    }
    this.item.removeSegments();
    const next = this.createPaperRect();
    this.item.addSegments(next.segments);
  }
  createPaperItem() {
    this.item = this.createPaperRect();
    this.item.strokeColor = new this.scope.Color(new this.scope.Color('#2196f3'));
  }
  editorConfig() {
    return new EditorConfig();
  }
  vectorKeys() {
    return [];
  }
  styleKeys() {
    return {
      include: [],
      exclude: []
    };
  }
  onStyleKeyUpdate(_key) {}
}